const zhCN = {
  "nav.home": "首页",
  "nav.about": "品牌介绍",
  "nav.goToSongbo": "前往崧博官网",

  "footer.tagline": "崧博出版事业有限公司经销品牌",
  "footer.subtitle": "人文历史与经典文本的再整理品牌",
  "footer.goToSongbo": "前往崧博官网",
  "footer.copyright": "© {{year}} 复刻文化 Fuko. All Rights Reserved.",

  "home.hero.subtitle": "崧博出版事业有限公司 经销品牌",
  "home.hero.brand": "复刻文化",
  "home.hero.tagline": "让经典重新被阅读",
  "home.hero.cta": "前往崧博官网",

  "home.brandIntro.imageTitle": "复刻文化",
  "home.brandIntro.imageSubtitle": "重新整理，重新诠释",
  "home.brandIntro.label": "品牌主张",
  "home.brandIntro.heading": "人文历史与经典文本的再整理品牌",
  "home.brandIntro.p1": "<0>复刻文化 Fuko</0> 是崧博出版经销品牌，聚焦经典文本、历史记忆与知识再诠释。专注于历史、人文社科、公版经典与小说类书籍的出版。",
  "home.brandIntro.p2": "我们相信，经典不应只存在于学术殿堂的书架上。透过重新整理、诠释与包装，让这些跨越时代的文本在当代焕发新生。",
  "home.brandIntro.statBooks": "已出版书籍",
  "home.brandIntro.statAuthors": "合作作者",
  "home.brandIntro.learnMore": "了解更多",

  "home.featured.label": "精选出版",
  "home.featured.heading": "近期出版品",
  "home.featured.subtitle": "每一本书都是对经典的重新诠释，为当代读者搭建通往历史与文学的桥梁。",
  "home.featured.viewAll": "前往崧博官网查看完整书目",

  "home.cta.heading": "在崧博官网，发现更多经典",
  "home.cta.subtitle": "复刻文化全系列出版品、最新书讯与完整书目，都在崧博出版官网。从历史到文学，从公版经典到当代创作，一站探索。",
  "home.cta.button": "前往崧博官网",

  "home.relationship.label": "品牌关系",
  "home.relationship.heading": "复刻文化 × 崧博出版",
  "home.relationship.p1": "<0>复刻文化</0>为崧博出版事业有限公司经销品牌。崧博出版拥有二十余年的专业出版经验，在文史类书籍领域具备深厚的编辑实力与通路资源。复刻文化借助这份专业底蕴，专注于人文历史与经典文本的再整理。",

  "about.hero.label": "About",
  "about.hero.heading": "品牌介绍",
  "about.hero.subtitle": "<0>崧博出版事业有限公司</0>经销品牌 —— 人文历史与经典文本的再整理品牌。",

  "about.brandStory.imageTitle": "品牌故事",
  "about.brandStory.imageSubtitle": "以文字跨越时代",
  "about.brandStory.heading": "让经典重新被阅读",
  "about.brandStory.p1": "<0>复刻文化</0>为<1>崧博出版事业有限公司</1>经销品牌，专注于历史、人文社科、公版经典与小说类书籍的出版。",
  "about.brandStory.p2": "复刻二字的灵感来自于传统印刷术中的「覆刻」概念 —— 将珍贵的古籍重新制版、印制，让经典文本得以流传。我们将这个概念延伸为品牌的核心理念：不只是复制，更是再创造；不只是重印，更是重新诠释。",
  "about.brandStory.p3": "我们相信，经典不应只存在于学术殿堂的书架上。透过重新整理、诠释与包装，让这些跨越时代的文本在当代焕发新生 —— 让历史成为可亲近的对话，让经典成为可阅读的当下。",

  "about.mission.title": "使命",
  "about.mission.desc": "让经典文本在当代重新被阅读、被理解、被讨论，搭建历史人文知识与现代读者之间的桥梁。",
  "about.vision.title": "愿景",
  "about.vision.desc": "成为华文世界最具影响力的人文历史与经典文本再整理品牌，建立完整的历史人文知识生态系统。",
  "about.value.title": "价值",
  "about.value.desc": "学术严谨、内容可信、设计典藏。每一本出版品都经过严格的编辑审校，确保品质与深度。",

  "about.songbo.heading": "复刻文化 × 崧博出版",
  "about.songbo.p1": "<0>复刻文化</0>为崧博出版事业有限公司经销品牌。崧博出版拥有二十余年的专业出版经验，在学术出版、教科书与文史类书籍领域具备深厚的编辑实力与通路资源。",
  "about.songbo.backHome": "回到首页",

  "bookCard.viewOnSongbo": "崧博官网",

  "notFound.title": "此页面尚未生成",
  "notFound.subtitle": "告诉我更多关于这个页面的信息，我就可以生成它",

  "lang.switchTo": "语言",

  "brand.imageAlt": "复刻文化 Fuko 品牌视觉"
};

export default zhCN;